module.exports = __webpack_public_path__ + "static/media/400090_02.87350dbf.png";